module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_0@3x.92fd0b9d.png";